import React, { useState } from "react";
import { Check } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { ExerciseLightbox } from "./ExerciseLightbox";
import { ExercisePreviewCard } from "./ExercisePreviewCard";
import { PremiumGlowButton } from "./PremiumGlowButton";
import { exercisePreviews, receiveBenefits } from "../data/receiveSection";
export function ReceiveSection() {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const shouldReduceMotion = Boolean(useReducedMotion());
  const handleOfferClick = () => {
    const offerSection = document.querySelector<HTMLElement>("#card");
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: shouldReduceMotion ? "auto" : "smooth",
        block: "start"
      });
      window.history.pushState(null, "", "#card");
      return;
    }
    window.location.hash = "card";
  };
  return <section aria-labelledby="receive-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] px-0 py-20 text-[#F8F8F6] sm:py-24 lg:py-28" data-id="element-178" data-mp="jjxvjnaiza4q">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-96 bg-[radial-gradient(circle_at_top,rgba(242,184,75,0.075),transparent_68%)]" data-id="element-179" data-mp="3tkmyoil4utn" />
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-12" data-id="element-180" data-mp="3q23ob4gpl568">
        <header className="text-center" data-id="element-181" data-mp="3v0x5b6v7feb5">
          <div className="flex items-center justify-center gap-3" data-id="element-182" data-mp="3v3t40xevm70n">
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-183" data-mp="3h9a5wy5ytpo5" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F2B84B] sm:text-xs" data-id="element-184" data-mp="3m1jwmgewmtrh">
              Vista previa
            </p>
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-185" data-mp="37dyp8aazy8dr" />
          </div>
          <h2 id="receive-heading" className="mt-4 text-[2rem] font-bold leading-tight tracking-[-0.035em] text-[#F8F8F6] sm:text-[2.5rem] lg:text-[3.25rem]" data-id="element-186" data-mp="3cbi5ffr98v8c">
            Lo Que Vas a Recibir
          </h2>
        </header>

        <div aria-label="Vistas previas de ejercicios" className="mt-10 grid w-full grid-cols-2 gap-x-3 gap-y-4 md:grid-cols-3 md:gap-5 lg:mt-14" data-id="element-187" data-mp="32evkkqyxi46b">
          {exercisePreviews.map((image, index) => <div key={image.src} className="min-w-0" data-id="element-188" data-mp="141iqfwtqbyky" data-mpi={index}>
              <ExercisePreviewCard src={image.src} alt={image.alt} index={index} onOpen={setSelectedIndex} data-id="element-189" data-mp="z5k6qmjcj4qv" />
            </div>)}
        </div>

        <motion.ul aria-label="Beneficios incluidos" initial={shouldReduceMotion ? false : "hidden"} whileInView="visible" viewport={{
        once: true,
        amount: 0.18
      }} variants={{
        hidden: {
          opacity: 0,
          y: 20
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.55,
            staggerChildren: 0.055
          }
        }
      }} className="mx-auto mt-14 max-w-[900px] overflow-hidden rounded-[20px] border border-[#30343A] bg-[#15191D] px-5 py-2 shadow-[0_24px_70px_rgba(0,0,0,0.26),0_0_36px_rgba(242,184,75,0.035)] sm:mt-16 sm:px-8 sm:py-3 lg:px-10" data-id="element-190" data-mp="u3cojf7xasg3">
          {receiveBenefits.map(benefit => <motion.li key={benefit} variants={shouldReduceMotion ? undefined : {
          hidden: {
            opacity: 0,
            y: 8
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} className="flex gap-3 border-b border-[#30343A]/75 py-4 text-sm leading-6 text-[#F8F8F6] last:border-b-0 sm:gap-4 sm:py-[18px] sm:text-base sm:leading-7" data-id="element-191" data-mp="2e3g14ijt1cb2">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#F2B84B]/45 bg-[#F2B84B]/10 text-[#F2B84B]" data-id="element-192" data-mp="2wrtffb943qhw">
                <Check aria-hidden="true" className="h-3.5 w-3.5 stroke-[2.5]" data-id="element-193" data-mp="35sj3ttw1mell" />
              </span>
              <span data-id="element-194" data-mp="3aqt2wfkw1zch">{benefit}</span>
            </motion.li>)}
        </motion.ul>

        <div className="mx-auto mt-12 flex max-w-[900px] justify-center px-1 sm:mt-14" data-id="element-195" data-mp="1bf9tjzvoap2a">
          <PremiumGlowButton onClick={handleOfferClick} data-id="element-196" data-mp="1gdl3ealywzki" />
        </div>
      </div>

      <ExerciseLightbox selectedIndex={selectedIndex} onSelectedIndexChange={setSelectedIndex} data-id="element-197" data-mp="1gfo1zj16s10u" />
    </section>;
}